import { useMutation } from "@tanstack/react-query";
import {
  basicInfo,
  blockProfile,
  careerDetails,
  onboardingDetails,
  partnerPreference,
  physicalMerital,
  reportProfile,
  uploadPhoto,
} from "api/onboard";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useBasicInfo = (options = {}) => {
  return useMutation({
    mutationFn: basicInfo,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message || "Basic info submitted");

      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usePhysicalMerital = () => {
  return useMutation({
    mutationFn: physicalMerital,
    onSuccess: (data) => {
      AlertNotification(
        "success",
        data?.message || "Physical and marital info submitted",
      );
    },
  });
};

export const useCareerDetails = () => {
  return useMutation({
    mutationFn: careerDetails,
    onSuccess: (data) => {
      AlertNotification(
        "success",
        data?.message || "Career Details info submitted",
      );
    },
  });
};

export const usePartnerPreference = () => {
  return useMutation({
    mutationFn: partnerPreference,
    onSuccess: (data) => {
      AlertNotification(
        "success",
        data?.message || "Partner Preference info submitted",
      );
    },
  });
};

export const useUploadPhoto = (options = {}) => {
  return useMutation({
    mutationFn: uploadPhoto,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useOnboardingDetails = () => {
  return useMutation({
    mutationFn: onboardingDetails,
  });
};

export const useReportProfile = (options = {}) => {
  return useMutation({
    mutationFn: reportProfile,
    onSuccess: (data, variables, context) => {
      AlertNotification(
        "success",
        data?.message || "Profile reported successfully!",
      );
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useBlockProfile = (options = {}) => {
  return useMutation({
    mutationFn: blockProfile,
    onSuccess: (data, variables, context) => {
      AlertNotification(
        "success",
        data?.message || "Profile blocked successfully!",
      );
      options.onSuccess?.(data, variables, context);
    },
  });
};
